// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3UVYQ","loaderOuter":"PageOverlayLoader_loaderOuter__GdSIL"};